<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12">
    <select
      [title]="getSelectedOptionLabel()"
      class="form-control hb-dropdown"
      [id]="control.key"
      [attr.placeholder]="control.placeholder || control.label"
      [attr.disable]="control.disabled"
      [formControlName]="control.key"
      (change)="onDropdownChange($event)"
    >
      <!-- <option value="undefined" disabled selected>{{control.placeholder || control.label}}</option> -->
      <option *ngFor="let opt of control.options" [value]="opt.key">{{ opt.value }}</option>
    </select>
  </div>
</div>
